<template>
    <div class="navigation" :class="{ 'navigation--master-doors': isMasterDoors }">
        <div class="navigation__container container">
            <div class="navigation__left">
                <nav class="navigation__left__list">
                    <!-- ITEM -->
                    <a
                        v-for="item in globalSettings.header_pages"
                        :key="item.id + 'nav'"
                        v-if="item.is_active"
                        class="navigation__left__list__item"
                        :href="item.link"
                        :style="{
                            display: 'flex',
                            gap: '5px',
                            alignItems: 'center',
                            flexDirection: item.position === 'left' ? 'row-reverse' : 'row'
                        }"
                    >
                        <span
                            :class="{ active: setActiveClass(item.link) }"
                            :style="getAnchorStyle(item)"
                            @mouseover="handleMouseOver($event, item)"
                            @mouseleave="handleMouseLeave($event, item)"
                        >
                            {{ item.column_name }}
                        </span>
                        <img v-if="item.icon" width="16px" :style="{ 'object-fit': 'contain' }" :src="item.icon" />
                    </a>
                </nav>
            </div>

            <div class="navigation__right">
                <li class="navigation__right__lang" v-for="locale in $i18n.locales" :key="locale.code">
                    <NuxtLink prefetch :to="switchLocalePath(locale.code)" :class="{ current: locale.code === $i18n.locale }">
                        {{ locale.name.substring(0, 2) }}
                    </NuxtLink>
                </li>
            </div>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import { mapGetters } from 'vuex';
import HeaderNavigationMixin from '~/mixins/HeaderNavigationMixin';

export default {
    name: 'Navigation',
    mixins: [HeaderNavigationMixin],
    computed: {
        ...mapGetters({
            isMasterDoors: 'global/getIsMasterDoors',
            globalSettings: 'global/globalSettings',
            getCurrentTheme: 'global/getCurrentTheme'
        })
    }
};
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
